import { useEffect } from 'react';
const PIXEL_ID = '1327135532923755';
const PIXEL_SCRIPT_ID = 'meta-pixel-script';
declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void;
      queue?: unknown[];
      push?: unknown;
      loaded?: boolean;
      version?: string;
    };
    _fbq?: unknown;
  }
}
export function MetaPixel() {
  useEffect(() => {
    if (document.getElementById(PIXEL_SCRIPT_ID)) {
      window.fbq?.('track', 'PageView');
      return;
    }

    /* eslint-disable @typescript-eslint/no-explicit-any */
    const f = window as any;
    const b = document;
    if (!f.fbq) {
      const n: any = function (...args: unknown[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      };
      f.fbq = n;
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = b.createElement('script');
      t.id = PIXEL_SCRIPT_ID;
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const s = b.getElementsByTagName('script')[0];
      s?.parentNode?.insertBefore(t, s);
    }
    /* eslint-enable @typescript-eslint/no-explicit-any */

    window.fbq?.('init', PIXEL_ID);
    window.fbq?.('track', 'PageView');
  }, []);
  return <noscript data-id="element-38" data-mp="1dela0texz64k">
      <img height="1" width="1" style={{
      display: 'none'
    }} alt="" src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-39" data-mp="1de1s3cpakhqj" />
    </noscript>;
}